import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {CustomPost} from '@app/blog/post/custom-post';
import {useParams} from 'react-router-dom';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';

const endpoint = (slugOrId: number | string, siteId: number | string) => `blogs/${siteId}/${slugOrId}`;




export function usePost(pageId?: number | string, siteId?: number | string) {
  const params = useParams();
  
 
  if (!pageId) {
    pageId = params.post_id;
  }
  if (!siteId) {
    siteId = params.site_id;
  }

  return useQuery({
    queryKey: [endpoint(pageId!, siteId!)],
    queryFn: () => fetchCustomPage(pageId!, siteId!),    
  });
}

function fetchCustomPage(
  slugOrId: number | string, 
  siteId: number | string
): Promise<CustomPost> {  
  return apiClient.get(endpoint(slugOrId, siteId)).then(response => response.data);
}
